// Copyright 2026. WebPros International GmbH. All rights reserved.

import styled, { keyframes } from 'styled-components';

const rotate = keyframes`
    to { transform: rotate(360deg); }
`;

export const StyledSvg = styled.svg`
    animation: ${rotate} 1s linear infinite;
    transform-origin: center;
`;
